import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import FormViewManager from "../../components/common/form/FormViewManager";
import TableCell from "../../components/common/ui/TableCell";

import TinyMCEpreview from "../../components/const/TinyMCEpreview";
import PhotoBoardReadonly from "../../components/const/Photo/PhotoBoardReadonly";
import PeopleView from "../../components/common/people/PeopleView";
import SignTableDocSingle from "../../components/approval/SignTable_doc_single";

/* OrderBody — FormViewManager children (뷰만 유지)
 * update / delete / edit 기능 제거
 * 기본정보 테이블 제거 (FormViewManager에서 제공하므로)*/
function OrderBody({ meta, data }) {
  const { id: projectId } = useParams();
  const navigate = useNavigate();
  const order = data; // alias
  const completions = order.completion || [];
  const [selectedCompletion, setSelectedCompletion] = useState(
    completions[0] || null
  );

  return (
    <>
      <div className="overflow-hidden mb-8">
        <table className="w-full text-sm table-fixed">
          <colgroup>
            <col style={{ width: "100px" }} />
            <col />
            <col style={{ width: "100px" }} />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <TableCell
                label="시공 담당자"
                colSpan={3}
                value={
                  <PeopleView
                    dns={data.dns}
                    // value={meta?.requestPeople || []}
                    placeholder="지정된 담당자 없음"
                  />
                }
              />
            </tr>
            <tr>
              <TableCell
                label="승인자"
                value={order.approval?.approver_name || "-"}
              />              
              <TableCell
                label="처리기간"
                // colSpan={3}
                value={
                  order.meta.start_date && order.meta.end_date
                    ? (() => {
                        const s = new Date(order.meta.start_date);
                        const e = new Date(order.meta.end_date);
                        const diff = Math.ceil((e - s) / 86400000);
                        return `${diff}일`;
                      })()
                    : "-"
                }
              />
            </tr>
            <tr>
              <TableCell
                label="시작날짜"
                value={order.meta.start_date || "-"}
              />
              <TableCell label="마감날짜" value={order.meta.end_date || "-"} />
            </tr>
          </tbody>
        </table>
      </div>

      {/* 지시사항 */}
      <div className="mb-6 border border-black">
        <div className="border-b border-black bg-gray-100 px-3 py-2 font-semibold text-body-bold">
          지시사항
        </div>

        <div className="px-3 py-4 min-h-[120px] whitespace-pre-line">
          <TinyMCEpreview
            html={meta.instructions || "<p>지시사항이 없습니다.</p>"}
          />
        </div>

        {/* 작성자 / 작성일 */}
        <div className="flex justify-end gap-6 px-3 py-2 text-sm text-gray-600 border-t border-black bg-gray-50">
          <span>
            작성일:{" "}
            {meta.start_date
              ? new Date(meta.start_date).toLocaleDateString("ko-KR")
              : "-"}
          </span>
          <span>작성자: {order.created_by.name || "-"}</span>
        </div>
      </div>

      <div className="mb-6">
          <SignTableDocSingle
            dns={data.dns}
            onlyLastApprover={true}
            showEmptyBox={true}
          />
      </div>

      {/* 조치내용 + 완료보고서 선택 */}
      <div className="mb-6 border border-black">
        <div className="flex items-center justify-between border-b border-black bg-gray-100 px-3 py-2 font-semibold">
          <div className="flex items-center text-body-bold">
            <span>조치내용</span>

            {completions.length > 0 && (
              <div className="flex items-center ml-2 relative">
                {/* 실제 select (보이진 않지만 존재함) */}
                <select
                  className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                  value={selectedCompletion?.dns || ""}
                  onChange={(e) => {
                    const comp = completions.find(
                      (c) => c.dns === e.target.value
                    );
                    setSelectedCompletion(comp || null);
                  }}
                >
                  {completions.map((comp) => (
                    <option key={comp.dns} value={comp.dns}>
                      {comp.title}
                    </option>
                  ))}
                </select>

                {/* 표시용 텍스트 */}
                <span className="text-sm font-semibold text-body-bold">
                  {selectedCompletion?.title}
                </span>
              </div>
            )}
          </div>

          {/* 승인 상태 */}
          {selectedCompletion?.approval &&
            (() => {
              const st = selectedCompletion.approval.is_approved;
              const label =
                { submit: "승인대기", approved: "승인", rejected: "반려" }[
                  st
                ] || "-";
              const cls = {
                submit: "bg-yellow-100 text-yellow-800",
                approved: "bg-green-100 text-green-800",
                rejected: "bg-red-100 text-red-800",
              }[st];

              return (
                <span
                  className={`px-2 py-1 text-xs font-medium rounded-full border ${cls}`}
                >
                  {label}
                </span>
              );
            })()}
        </div>

        <div className="px-3 py-4 min-h-[120px] whitespace-pre-line">
          {selectedCompletion ? (
            selectedCompletion.meta.detail ? (
              <TinyMCEpreview html={selectedCompletion.meta.detail} />
            ) : (
              <p className="text-gray-500">조치내용이 없습니다.</p>
            )
          ) : (
            <div className="flex flex-col items-center justify-center h-full text-gray-500">
              <p className="mb-2">아직 완료보고서가 없습니다.</p>
              <button
                className="btn-create"
                onClick={() =>
                  navigate(`/project/${projectId}/const/ordercomplete/new`, {
                    state: {
                      order: order
                    }
                  })
                }
              >
                작성하기
              </button>
            </div>
          )}
        </div>

        {/* 메타정보 */}
        {selectedCompletion && (
          <div className="flex justify-end gap-6 px-3 py-2 text-sm text-gray-600 border-t border-black bg-gray-50">
            <span>
              작성일:{" "}
              {selectedCompletion.created_at
                ? new Date(selectedCompletion.created_at).toLocaleDateString(
                    "ko-KR"
                  )
                : "-"}
            </span>
            <span>작성자: {selectedCompletion.created_by?.name || "-"}</span>
            <span>
              승인자: {selectedCompletion.approval?.approver_name || "-"}
            </span>
          </div>
        )}
      </div>

      {/* 사진대지 */}
      <div className="mb-6 border-black">
        <div className="tbl-label-bg">
          사진대지
        </div>

        <div className="px-3 py-4 border-r border-l border-b border-black">
          {selectedCompletion?.meta.photoboard ? (
            <PhotoBoardReadonly
              photoboardId={selectedCompletion.meta.photoboard}
            />
          ) : (
            <p className="text-gray-500">연결된 사진대지가 없습니다.</p>
          )}
        </div>
      </div>

      {selectedCompletion?.dns && (
        <div className="mb-6">
          <SignTableDocSingle
            dns={selectedCompletion.dns}
            onlyLastApprover={true}
            showEmptyBox={true}
          />
        </div>
      )}


    </>
  );
}

/* OrderView — FormViewManager로 감싸기*/
export default function OrderView() {
  const { workorderId, id: project } = useParams();

  return (
    <FormViewManager
      params={{
        project,
        dns: workorderId,
        module: "const",
        doc_type: "workorder",
      }}
      doc_name="작업지시서"
      app_action={true}
    >
      <OrderBody />
    </FormViewManager>
  );
}
